interface InjuryMatrix {
    bodyAreasToBodyParts: Record<number, number[]>;
    bodyPartsToInjuryTypes: Record<number, number[]>;
}

interface InjuryTypeMatrix {
    injuryTypeMapping: Record<number, number>;
}

export const injuryMatrix: InjuryMatrix = {
    bodyAreasToBodyParts: {
            1: [8, 9, 10, 11],                                      //Arm/Wrist/Hand/Fingers
            2: [5, 6, 7],                                           //Back/Shoulder/Neck
            3: [1, 2, 3, 4, 21, 22, 25],                            //Head/Face/Senses
            4: [12, 13, 14],                                        //Hips/Pelvis/Genitals
            5: [24],                                                //Internal Injury
            6: [15, 16, 17, 18, 19],                                //Leg/Knee/Ankle/Feet/Toe
            7: [20, 23, 26]                                         //Ribs/Chest/Torso
    },

    bodyPartsToInjuryTypes: {
            1: [1, 2, 7, 11, 12, 18, 20, 30, 32, 35, 37, 38, 39,],  //Head    
            2: [1, 2, 3, 7, 20, 23],                                //Face
            3: [1, 2, 7, 11, 17, 20, 23],                           //Jaw
            4: [1, 2, 7, 11, 23, 20],                               //Nose
            5: [1, 2, 7, 11, 20, 23, 25],                           //Back
            6: [1, 2, 7, 8, 11, 20, 23, 25],                        //Shoulder
            7: [1, 2, 7, 11, 20, 23, 25],                           //Neck
            8: [1, 2, 7, 11, 20, 23],                               //Arm
            9: [1, 2, 7, 11, 20, 23],                               //Wrist
            10: [1, 2, 7, 11, 20, 23],                              //Hand
            11: [1, 2, 7, 11, 20, 23],                              //Fingers
            12: [1, 2, 7, 11, 20, 23],                              //Hips
            13: [1, 2, 7, 11, 20, 23],                              //Pelvis
            14: [1, 2, 7, 20, 23],                                  //Genitals
            15: [1, 2, 7, 8, 11, 20, 23],                           //Leg
            16: [1, 2, 7, 8, 11, 20, 23],                           //Knee
            17: [1, 2, 7, 8, 11, 20, 23],                           //Ankle
            18: [1, 2, 7, 8, 11, 20, 23],                           //Foot
            19: [1, 2, 7, 8, 11, 20, 23],                           //Toe
            20: [1, 7, 11, 23],                                     //Ribs
            21: [21, 22],                                           //Psychological                                      
            22: [4, 6, 15, 16, 20, 24, 26, 27, 28, 29],             //Senses Affected          
            23: [1, 7, 11, 23],                                     //Chest
            24: [13],                                               //Internal
            25: [1, 7, 9, 10, 11, 26, 27, 31, 32, 33, 34],          //Eye
            26: [1, 7, 23]                                          //Torso
    }
};

export const injuryTypeMatrix: InjuryTypeMatrix = {
    injuryTypeMapping: {
        2: 1,                                                       //Burns 
        18: 30,                                                     //Memory Loss - Temporary
        9: 10,                                                      //Vision Impacted - Temporary
        15: 28,                                                     //Loss of smell - Temporary
        16: 29,                                                     //Loss of taste - Temporary
        26: 27                                                      //Hearing Impacted - Temporary
    }
}